


























import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import Header from '@components/pageComponents/Header/index.vue';
import Footer from '@components/pageComponents/Footer/index.vue';
import Nav from '@components/pageComponents/Nav/index.vue';
import Breadcrumb from '@/components/Breadcrumb';

import { userInfor, logout, loginState, isCore } from '@/useable/login';
import request from '@utils/request';
import { session } from '@utils/storage';
import _ from 'lodash';

export default defineComponent({
  name: 'Layout',
  components: {
    Header,
    Footer,
    Nav,
    Breadcrumb
  },
  setup(prop: any, { root } ) {
    const menus = ref([]);
    const loading = ref(false);
    const handleLogout = () => {
      logout(true);
      menus.value = [];
    };

    const noHeaderPage = computed(()=>{
      return root.$route.path.indexOf('pdf') > 0 || root.$route.path.indexOf('portal') > 0;
    });

    const getMenus = async () => {
      loading.value = true;
      const res = await request('common', 'getMenus', {});
      if (res.code === 2000) {
        const testData = _.cloneDeep(res.data);
        testData.map((item: { path: string; childMenuList: any[]; }) =>{
          if (item.path === '/set') {
            item.childMenuList = item.childMenuList.filter((i: { path: string; }) => i.path !== 'supply');
          }

          return item;
        });
        menus.value = isCore.value ? res.data : testData;
      } else {
        // await root.$router.replace({ name: 'Login' });
        // session.remove('user-infor');
      }
      loading.value = false;
    };

    watch(() => loginState.value, (newVal: boolean, oldVal) => {
      if (newVal) {
        getMenus();
        if (oldVal !==undefined) {
          root.$router.push({ name: 'Home' });
        }
      }
    }, { immediate: true });

    return {
      loginState,
      isCore,
      userInfor,
      handleLogout,
      menus,
      noHeaderPage,
      loading,
    };
  },
});
